import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const commentCreate = payload => AxiosClient.post('/comment', payload);
const getCommentList = (params) => AxiosClient.get('/comment', params);
const showComment = (commentId, query) => AxiosClient.get(`/comment/${commentId}`, query);
const updateComment = (commentId, payload) => AxiosClient.put(`/comment/${commentId}`, { ...payload });
const deleteComment = (commentId, query) => AxiosClient.delete(`/comment/${commentId}?projectId=${query.projectId}&moduleId=${query.moduleId}&module=${query.module}`)

export {
    commentCreate,
    getCommentList,
    showComment,
    updateComment,
    deleteComment
}